module.exports = __webpack_public_path__ + "img/old_photo_of_cj.81969dee.jpg";